export default __webpack_public_path__ + "static/media/COM23.f76465ed.webp";